export const Options = {
    Salutation: [
        { text: "Herr/Frau", value: "D" },
        { text: "Herrn", value: "M" },
        { text: "Frau", value: "W" },
        { text: "Undefiniert", value: "L" },
    ],
    BecomingAwareThrough: [
        { text:"Agentur für Arbeit",value:"Agentur für Arbeit"},
        { text:"Facebook",value:"Facebook" },
        { text:"Instagram",value:"Instagram" },
        { text:"Jobware",value:"Jobware" },
        { text:"LinkedIn",value:"LinkedIn" },
        { text:"Messen",value:"Messen" },
        { text:"Mitarbeiterempfehlung",value:"Mitarbeiterempfehlung" },
        { text:"Print-Anzeigen",value:"Print-Anzeigen" },
        { text:"Stellenanzeigen.de",value:"Stellenanzeigen.de" },
        { text:"StepStone.de",value:"StepStone.de" },
        { text:"TikTok",value:"TikTok" },
        { text:"Xing",value:"Xing" },
        { text:"Sonstiges",value:"Sonstiges" },
    ]
}
